import axios from 'axios';
import config from 'config';
import { createApi } from 'utils/api';

const productionV1Api = axios.create({
  baseURL: config.productionV1ApiBaseUrl,
  params: {
    apikey: config.apiKey,
  },
});

const createProductionV1Api = createApi(productionV1Api);
export const getProductionV1Data = createProductionV1Api('get');
export const patchProductionV1Data = createProductionV1Api('patch');
export const postProductionV1Data = createProductionV1Api('post');
export const putProductionV1Data = createProductionV1Api('put');
export const deleteProductionV1Data = createProductionV1Api('delete');